import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    list-style: none;
    text-decoration: none;
    

}
input:focus, textarea:focus, select:focus{

    outline: 1px solid var(--black);
}

/* html{
    scroll-padding-top: 70px;
    scroll-behavior: smooth;
} */
:root{
    --black: #000;
    --blue-grey: #313546;
    --red: #eb3238;
    --white: #f4f4f4;
    --light-grey: #838d95;
    --grey: #3c3c3b;
    --raleway: 'Raleway', sans-serif;
    --roboto: 'Roboto', sans-serif;
    --car-info: rgba(255, 255, 255, 0.914);
}
`;
